import { render, staticRenderFns } from "./OrderBillDetails.vue?vue&type=template&id=3676f5bb"
import script from "./OrderBillDetails.vue?vue&type=script&lang=js"
export * from "./OrderBillDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports